<ng-template #header>
    <shared-vcard-for-wizzard [title]="menuFlowTitle$ | async" [description]="menuFlowDescription$ | async"
        [icon]="false" [stats]="(menuFlowStats$ | async)" [tagImages]="(menuFlowTagImages$ | async)"
        [collapsed]="collapseHeader" [loading]="(imageLoading$ | async)" [imageSrc]="(menuFlowImage$ | async)">
    </shared-vcard-for-wizzard>
</ng-template>

<ng-template #footer>
    <shared-modal-item-actions [twoColumnsAlign]="twoColumnsAlign" [twoColumnsAdjust]="twoColumnsAdjust"
        [disabled]="(canUseCTAButton$ | async) === false" [twoColumnsMarginBottom]="twoColumnsMarginBottom"
        [quantity]="menuFlowQuantity$ | async" [isQuantityVisible]="modalData.type !== 'upsell'"
        [buttonLabel]="menuFlowAcceptBtnLabel$ | async" [buttonPrice]="menuFlowAcceptBtnLabelPrice$ | async"
        (onIncrement)="handleMenuFlowIncrement($event)" (onDecrement)="handleMenuFlowDecrement($event)"
        (onRemove)="handleMenuFlowRemove($event)" (onClick)="handleMenuFlowCtaClick($event)" [minimumHide]="minimumHide"
        [remove]="remove">
    </shared-modal-item-actions>
</ng-template>

<ng-template #subHeader>
    <shared-wizzard-sub-nav [activePageIdentifier]="scrollCurrentActivePageIdentifier$ | async"
        (onClick)="handleSubNavClick($event)" [menuFlowPages]="(menuFlowPagesFiltered$ | async)">
    </shared-wizzard-sub-nav>
</ng-template>

<shared-modal-type-dynamic-height (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
    [dimmedBg]="dimmedBg" [shadow]="shadow" [size]="size" [header]="header"
    [subHeader]="showSubHeader ? subHeader : null" [footer]="footer" [minHeight]="minHeight" [modalData]="modalData"
    [center]="true" (onCloseClick)="handleCloseClick($event)" class="modal-view-for-standard-menu-flow">

    <shared-wizzards [showDisclaimer]="(menuFlowStats$ | async)?.cals > 0" [type]="modalData.type"
        [menuFlowId]="modalData.menuFlowId" [locationNo]="modalData.locationNo">
    </shared-wizzards>

</shared-modal-type-dynamic-height>